export default __webpack_public_path__ + "static/media/1755.40c7ccf8.png";